import { BaseException } from 'exceptions/baseException';

export class NotFoundException extends BaseException {
  static status = 404;

  constructor(message?: string) {
    super(message, NotFoundException.status);
  }
}
